import React from "react";
import ReactDOM from "react-dom";
import classes from "./modal_wrapper.module.css";
import util from "../../../styles/utilities.module.css";

const ModalWrapper = ({ modalProps }) => {

    const { isOpen, description, leftBtnHandler, rightBtnHandler, buttons } = modalProps;
    const { leftBtn, rightBtn, isToggleStyle = false } = buttons;


    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className={`${util.modalOverlay} ${classes["modal-overlay"]}`} role="dialog" aria-modal="true">
            <div className={`${util.modalSurface} ${classes.modal}`}>
                <h4 className={classes.body}>{description}</h4>
                <div className={classes.confirmationBtnContainer}>
                    {/* When isToggleStyle is true, swap visual emphasis between buttons */}
                    <button
                        onClick={leftBtnHandler}
                        type="button"
                        className={`${util.btn} ${util['btn--ghost']} ${isToggleStyle ? classes.rightBtn : classes.leftBtn}`}
                    >
                        {leftBtn}
                    </button>
                    <button
                        onClick={rightBtnHandler}
                        type="button"
                        className={`${util.btn} ${isToggleStyle ? util['btn--primary'] : ''} ${isToggleStyle ? classes.leftBtn : classes.rightBtn}`.trim()}
                    >
                        {rightBtn}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ModalWrapper;
